import './styles/applied-filter-display.scss'

import React       from 'react'
import PropTypes   from 'prop-types'
import { connect } from 'react-redux'

import { Label, Icon } from 'semantic-ui-react'
import moment from 'moment'

const DATETIME_FORMAT = 'MM/DD/YYYY h:mm A'

class AppliedFilterDisplay extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    filterCriteria: PropTypes.object.isRequired,
  }

  handleMetadataRemove = (itemIndex) => {
    const newFilterConfig = { ...this.props.filterCriteria.jobs }
    newFilterConfig.metadataFilters.splice(itemIndex, 1)
    this.props.onChange(newFilterConfig)
  }

  handleDeliveryTimeRemove = () => {
    const newFilterConfig = { ...this.props.filterCriteria.jobs }
    newFilterConfig.deliveryTimeFilter = undefined
    this.props.onChange(newFilterConfig)
  }

  handleParentIdRemove = () => {
    const newFilterConfig = { ...this.props.filterCriteria.jobs }
    newFilterConfig.parentIdFilter = undefined
    this.props.onChange(newFilterConfig)
  }

  handleIdRemove = () => {
    const newFilterConfig = { ...this.props.filterCriteria.jobs }
    newFilterConfig.idFilters = undefined
    this.props.onChange(newFilterConfig)
  }

  render() {
    const {
      filterCriteria: { jobs: { metadataFilters = [], deliveryTimeFilter, idFilters = [], parentIdFilter } = {} } = {},
    } = this.props

    return (
      <div className="applied-filter-display">
        <Label.Group>
          {metadataFilters.map((mf, index) => {
            return (
              <Label key={index}>
                Metadata
                <Label.Detail>
                  {mf.key}: {mf.value}
                </Label.Detail>
                <Icon
                  name="close"
                  onClick={() => {
                    this.handleMetadataRemove(index)
                  }}
                />
              </Label>
            )
          })}

          {deliveryTimeFilter && deliveryTimeFilter.after && deliveryTimeFilter.before && (
            <Label>
              Delivery
              <Label.Detail>start: {moment(deliveryTimeFilter.after).format(DATETIME_FORMAT)}</Label.Detail>
              <Label.Detail>end: {moment(deliveryTimeFilter.before).format(DATETIME_FORMAT)}</Label.Detail>
              <Icon
                name="close"
                onClick={() => {
                  this.handleDeliveryTimeRemove()
                }}
              />
            </Label>
          )}

          {parentIdFilter && (
            <Label>
              Parent Job
              <Label.Detail>{parentIdFilter}</Label.Detail>
              <Icon
                name="close"
                onClick={() => {
                  this.handleParentIdRemove()
                }}
              />
            </Label>
          )}

          {idFilters && idFilters.length !== 0 && (
            <Label>
              Job
              <Label.Detail>{idFilters[0]}</Label.Detail>
              <Icon
                name="close"
                onClick={() => {
                  this.handleIdRemove()
                }}
              />
            </Label>
          )}
        </Label.Group>
      </div>
    )
  }
}

const mapDispatchToProps = {}
const mapStateToProps    = (state) => ({
  filterCriteria: state.items.filterCriteria,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppliedFilterDisplay)
